import { combineReducers } from "redux";
import categories from "./categories";
import taskDetails from "./taskDetails";

export default combineReducers({
  categories,
  taskDetails
});
